var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgent = function SvgAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3343 8.33341C12.1753 8.33341 13.6676 6.84103 13.6676 5.00008C13.6676 3.15913 12.1753 1.66675 10.3343 1.66675C8.49336 1.66675 7.00098 3.15913 7.00098 5.00008C7.00098 6.84103 8.49336 8.33341 10.3343 8.33341Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.834 18.3335C17.834 14.1914 14.4761 10.8335 10.334 10.8335C6.1919 10.8335 2.83398 14.1914 2.83398 18.3335",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3337 18.3335L12.0003 16.2502L10.3337 10.8335L8.66699 16.2502L10.3337 18.3335Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAgent;